import { CreateUserType, useCreateUserMutation } from '@/api/selfService';
import { ValidationError } from '@/api/ValidationError';
import yup from '@/yup/yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { Button, TextField, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { t } from 'i18next';
import { enqueueSnackbar } from 'notistack';
import { useForm } from 'react-hook-form';

export const Route = createFileRoute('/selfServiceCreateUser')({
    component: SelfServiceCreateUserComponent,
})

function SelfServiceCreateUserComponent() {

    const schema = yup.object().shape({
        scoutId: yup.string().required(),
        email: yup.string().email().required(),
    }).required();

    const { register, handleSubmit, formState: { isDirty, isValid } } = useForm<CreateUserType>({
        resolver: yupResolver<CreateUserType, any, any>(schema),
        mode: "onBlur",
        shouldFocusError: true,
    });
    const navigate = useNavigate();

    const createUser = useCreateUserMutation(
        () => {
            enqueueSnackbar(t('message.userCreated'), { variant: 'success' });
            navigate({ to: "/begin" });
        },
        (error) => {
            if (error instanceof ValidationError) {
                enqueueSnackbar(t('error.message', { message: t('error.code.' + error.code) }), { variant: 'error' });
            } else {
                enqueueSnackbar(t('error.default'), { variant: 'error' });
            }
        }
    );

    const onSubmit = (data: CreateUserType) => {
        console.log('onSubmit')
        if (isValid) {
            createUser.mutate(data);
        }
    }

    return (
        <div style={{ padding: 16 }}>
            <Typography variant="h5" gutterBottom>
                {t('action.createUser')}
            </Typography>
            <Typography variant="body1" gutterBottom>
                {t('message.createUser')}
            </Typography>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={1}>
                    <Grid
                        size={{
                            xs: 6,
                            md: 3,
                            lg: 2
                        }}>
                        <TextField
                            defaultValue={''} {...register("scoutId")}
                            label={t('property.member.scoutId')}
                            required={true}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={1}>
                    <Grid
                        size={{
                            xs: 6,
                            md: 3,
                            lg: 2
                        }}>
                        <TextField
                            defaultValue={''} {...register("email")}
                            label={t('property.member.emailPrimary')}
                            required={true}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid
                        size={{
                            xs: 12,
                            md: 6,
                            lg: 4
                        }}>
                        <Button type="submit" variant="contained" disabled={!isDirty || !isValid}>
                            {t('action.createUser')}
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </div>
    )
}
